import { useLayoutEffect, useRef } from 'react';
import { useRefMerger } from './useRefMerger';
/**
 * Allows us to reuse the `ref` from `forwardRef` within the component
 * See https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
 */
export function useCombinedRef(...refs) {
    const targetRef = useRef(null);
    const merge = useRefMerger(...refs);
    useLayoutEffect(() => merge(targetRef.current), [merge]);
    return targetRef;
}
//# sourceMappingURL=useCombinedRef.js.map